import { render, staticRenderFns } from "./ScrollTop.vue?vue&type=template&id=08e73740&scoped=true"
import script from "./ScrollTop.vue?vue&type=script&lang=js"
export * from "./ScrollTop.vue?vue&type=script&lang=js"
import style0 from "./ScrollTop.vue?vue&type=style&index=0&id=08e73740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e73740",
  null
  
)

export default component.exports